export const ADMIN_TABLE_HEADERS = [
  { title: "Admin Id", key: "id" },
  { title: "Name", key: "name" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Email Address", key: "email" },
  { title: "Role", key: "role" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const CUSTOMER_TABLE_HEADERS = [
  { title: "Customer Id", key: "id" },
  { title: "Name", key: "name" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Email Address", key: "email" },
  { title: "Bookings", key: "bookings" },
  { title: "Revenue", key: "revenue" },
  { title: "Cancellations", key: "cancellations" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const SEARCH_TABLE_HEADERS = [
  { title: "Date", key: "date" },
  { title: "Source", key: "source" },
  { title: "Destination", key: "destination" },
];

export const OPERATOR_TABLE_HEADERS = [
  { title: "Operator Id", key: "id" },
  { title: "Name", key: "name" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Fleet Size", key: "fleetSize" },
  { title: "Revenue", key: "revenue" },
  { title: "Bookings", key: "bookings" },
  { title: "Onboarding Progress", key: "onbordingProgress" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const BOOKING_TABLE_HEADERS = [
  { title: "Booking Id", key: "id" },
  { title: "Booking Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "From - To Location", key: "fromTo" },
  { title: "Passengers", key: "passengers" },
  { title: "Total Price", key: "totalPrice" },
  { title: "Booking Device", key: "bookingDevice" },
  { title: "Booking Status", key: "bookingStatus", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const BUS_TABLE_HEADERS = [
  { title: "Bus Id", key: "id" },
  { title: "Bus No", key: "busNo" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Route Details", key: "routeDetails" },
  { title: "Revenue", key: "revenue" },
  { title: "Bookings", key: "bookings" },
  { title: "Onboarding Progress", key: "onboardingProgress" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const SETTLEMENT_TABLE_HEADERS = [
  { title: "Settlement Id", key: "id" },
  { title: "Operator Name", key: "operatorName" },
  { title: "Operator Id", key: "operatorId" },
  { title: "Travels Name", key: "travelsName" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Bus Number", key: "busNumber" },
  { title: "Account Number", key: "accountNumber" },
  { title: "Amount Settled", key: "amount" },
  { title: "Bank Reference Number", key: "referenceNumber" },
  { title: "Settlement Status", key: "settlementStatus", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const CITY_TABLE_HEADERS = [
  { title: "City Id", key: "id" },
  { title: "City Name", key: "cityName" },
  { title: "Created Date", key: "createdAt" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const TRANSACTION_TABLE_HEADERS = [
  { title: "Customer Id", key: "customerId" },
  { title: "Customer Name", key: "customerName" },
  { title: "Created Date", key: "createdAt" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Pay U Reference", key: "payUReference" },
  { title: "Pay U Transaction Id", key: "payUTransactionId" },
  { title: "Amount", key: "amount" },
  { title: "Amount Status", key: "amountStatus" },
  { title: "Booking Status", key: "bookingStatus" },
  { title: "Refunded", key: "refundStatus", auth: true },
];

export const COUPON_TABLE_HEADERS = [
  { title: "Coupon Id", key: "id" },
  { title: "Coupon Code", key: "couponCode" },
  { title: "Created Date", key: "createdAt" },
  { title: "Created By", key: "createdBy" },
  { title: "Coupon Type", key: "couponType" },
  { title: "Discount", key: "discount" },
  { title: "Valid Days", key: "validDays" },
  { title: "Minimum Fare", key: "minimumFare" },
  { title: "Used Count", key: "usedCount" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const REPORT_TABLE_HEADERS = [
  { title: "Trip ID", key: "tripId" },
  { title: "Trip Number", key: "tripNumber" },
  { title: "Route ID", key: "routeId" },
  { title: "Trip Start Time", key: "tripStartTime" },
  { title: "Trip Type", key: "tripType" },
  { title: "Total Bookings", key: "totalBookings" },
  { title: "Total Revenue", key: "totalRevenue" },
];

export const REFFERAL_TABLE_HEADERS = [
  { title: "Refferrer", key: "id" },
  { title: "Created At", key: "createdAt" },
  { title: "Type", key: "type" },
  { title: "Total Refferals", key: "totalRefferals" },
  { title: "Successfull Refferals", key: "successfullRefferals" },
  { title: "Reward Earned", key: "rewardsEarned" },
  { title: "Wallet Balance", key: "walletBalance" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const VIEW_REFFERAL_TABLE_HEADERS = [
  { title: "Referee", key: "referee" },
  { title: "Singup At", key: "signupDate" },
  { title: "Type", key: "type" },
  { title: "Bookings", key: "bookings" },
  { title: "Revenue", key: "revenue" },
  { title: "Referral bonus", key: "referralBonus" },
  { title: "Status", key: "status", auth: true },
];

export const FAQ_TABLE_HEADERS = [
  { title: "Questions", key: "questions" },
  { title: "Type", key: "type" },
  { title: "Category", key: "category" },
  { title: "Answer", key: "answer" },
  { title: "Action", key: "actions", auth: true },
];

export const FARE_DISTRIBUTION_HEADERS = [
  { title: "Booking Id", key: "bookingId" },
  { title: "Total Passengers", key: "totalPassengers" },
  { title: "Luggage Fare", key: "luggageFare" },
  { title: "Route Bus Fee", key: "routeBusFee" },
  { title: "Total Amount", key: "totalAmount" },
  { title: "Wallet Points Used", key: "walletPointsUsed" },
  { title: "Discounted Price", key: "discountedPrice" },
  { title: "Final Fare", key: "finalFare" },
  { title: "Booking Status", key: "bookingStatus" },
  { title: "Payment Status", key: "status" },
];

export const WALLET_HEADERS = [
  { title: "Created At", key: "created_at" },
  { title: "Amount", key: "amount" },
  { title: "Balance After", key: "balance_after_transaction" },
  { title: "Type", key: "type" },
  { title: "Reference Type", key: "reference_type" },
  { title: "Reference ID", key: "reference_id" },
  { title: "description", key: "description" },
  { title: "Created By", key: "initiator_id" },
];

export const POS_HEADERS = [
  { title: "Bus Id", key: "id" },
  { title: "Bus No", key: "busNo" },
  { title: "Last Sync Timestamp", key: "lastSyncTime" },
  { title: "Device Id", key: "deviceId" },
  // { title: "Route Details", key: "routeDetails" },
  { title: "Revenue", key: "revenue" },
  { title: "POS bookings", key: "posBookings" },
  { title: "Online Bookings", key: "onlineBookings" },
  { title: "Status", key: "status" },
  { title: "Action", key: "actions", auth: true },
];
export const POS_BOOKING_HEADERS = [
  { title: "Ticket Id", key: "id" },
  { title: "Bus Id", key: "busId" },
  { title: "Bus No", key: "busNo" },
  { title: "Device Id", key: "deviceId" },
  { title: "Created At", key: "createdAt" },
  { title: "Booking Type", key: "bookingType" },
  { title: "Passengers", key: "passengers" },
  { title: "Price", key: "price" },
  { title: "Payment", key: "payment" },
];

export const BUSES_OVERVIEW_HEADERS = [
  { title: "Bus Id", key: "id" },
  { title: "Bus No", key: "busNo" },
  { title: "Travels Name", key: "travelsName" },
  { title: "Action", key: "actions", auth: true },
];

export const STAFF_HEADERS = [
  { title: "Staff Id", key: "id" },
  { title: "Name", key: "name" },
  { title: "Phone Number", key: "phoneNumber" },
  { title: "Role", key: "role" },
  { title: "Linked Buses", key: "linkedBuses" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const AD_LIST_HEADERS = [
  { title: "Id", key: "id" },
  { title: "Max Count", key: "maxCount" },
  { title: "Image", key: "image" },
  { title: "Title", key: "title" },
  { title: "Used Count", key: "usedCount" },
  { title: "Created At", key: "createdAt" },
  { title: "Created By", key: "createdBy" },
  { title: "Updated At", key: "updatedAt" },
  { title: "Updated By", key: "updatedBy" },
  { title: "Status", key: "status", auth: true },
  { title: "Action", key: "actions", auth: true },
];

export const AD_ROUTE_USAGE_HEADERS = [
  { title: "Route Id", key: "routeId" },
  { title: "City Id", key: "cityId" },
  { title: "Bus Id", key: "busId" },
  { title: "Current Usage Count", key: "currentUsageCount" },
  { title: "Active", key: "status" },
];

export const AD_BUS_LEVEL_USAGE_HEADERS = [
  { title: "Bus Id", key: "id" },
  { title: "Route Count", key: "routeCount" },
  { title: "Current Usage Count", key: "usageCount" },
  { title: "Routes", key: "routes", sortable: false },
];

export const AD_ASSIGNED_TICKETS_HEADERS = [
  { title: "Ticket Id", key: "id", sortable: false },
  { title: "Route Id", key: "routeId", sortable: false },
  { title: "Trip Id", key: "tripId", sortable: false },
  { title: "Trip Session Id", key: "tripSessionId", sortable: false },
  { title: "From", key: "from", sortable: false },
  { title: "To", key: "to", sortable: false },
  { title: "Booked At", key: "createdAt", sortable: false },
  { title: "Passenger Count", key: "passengerCount", sortable: false },
  { title: "Child Count", key: "childCount", sortable: false },
  { title: "Luggage Count", key: "luggageCount", sortable: false },
  { title: "Total Amount", key: "totalAmount", sortable: false },
  { title: "Booking Method", key: "bookingMethod", sortable: false },
  { title: "Payment Method", key: "paymentMethod", sortable: false },
  { title: "Payment Status", key: "paymentStatus", sortable: false },
];
